<template>
  <div class="content">
    <form>
      <calculation-form :datas="dataall"></calculation-form>
    </form>
    <b-modal id="modal-close" centered>
      <h4>
        {{$t('Sizda saqlanmagan malumotlar mavjud. Saqlansinmi?')}}
      </h4>

      <template #modal-footer="{ ok, cancel, hide }">
        <button type="button" class="btn btn-success" style="margin-bottom: 16px;"
          @click="$root.$refs.calculation.Savedokument()">{{$t('Да')}}</button>
        <button type="button" class="btn btn-danger" @click='Home()'>{{$t('Нет')}}</button>
        <button type="button" class="btn btn-primary" @click="cancel()">{{$t('Отмена')}}</button>
      </template>
    </b-modal>
  </div>
</template>
<script>
import CalculationForm from "./Form.vue"
export default {
  components: {CalculationForm},
  watch: {
    dataall: {
      deep: true,
      handler(val, oldVal) {
        this.$store.state.saved += 1;
      }
    }
  },
  methods:{
    Home() {
        this.$store.state.saved = null;
        this.$bvModal.hide('modal-close');
        this.$router.push({ name: "Калкулация" });
      }
  },
  beforeRouteLeave(to, from, next) {
    if (this.$store.state.saved == null) {
      this.$store.state.saved = null;
      next();
    } else {
      this.$bvModal.show("modal-close");
    }
  },
  data() {
    return {
      dataall: {
        created_at: new Date().valueOf().toString().slice(0, 10),
        updated_at: new Date().valueOf().toString().slice(0, 10),
        product_id : 0,
        count_all: 1,
        comment: "",
        unit:"",
        calculation_table : [
          {
            "unit":"",
            "product_id": 0,
            "count": 1
          }
        ]
      }
    };
  }
};
</script>
